module.exports = __webpack_public_path__ + "img/GDQ-svarsstapel_30.6670cc25.gif";